import { IConfigsType } from '../../types'

const fwSmartKitchenOperational: IConfigsType = {
  'fw_wingstop-customized-reports-7375b6fb': {
    '/:brand/smart_kitchen_operational': {
      disableAutoMargin: true,
      feV2: {
        type: 'FE V2',
        configPath: 'fw_wingstop/smart_kitchen_operational',
        height: '100vh',
      },
    },
  },
}

export default fwSmartKitchenOperational
